<template>
<div class="main my">
  <!-- 添加私教课 -->
  <div class="model-box bcw fs2 clear">
    <h2 class="fs4 tac mtn mbw">私教课</h2>
    <van-row class="mbn plm">
      <van-col span="6">{{coachjob | titleFilter}}</van-col>
      <van-col span="18">{{coachprice}}元/课时</van-col>
    </van-row>
    <van-row class="mbn plm">
      <van-col span="6">课时数</van-col>
      <van-col span="18">{{postForm.data.num}}课时</van-col>
    </van-row>
    <van-row class="mbn plm">
      <van-col span="6">场馆</van-col>
      <van-col span="18">{{clubInfo.title}}</van-col>
    </van-row>
    <div class="right mtm mbw">总价：<span class="red fs4">￥{{totalPrice}}元</span></div>
  </div>

  <form class="clear" @submit.prevent="checkForm" v-cloak>
    <van-cell-group>
      <van-field v-model="userInfo.name" label="姓名" placeholder="请输入" clearable :disabled="true" />
      <van-field v-model="userInfo.mobile" type="tel" label="电话" placeholder="请输入" clearable :disabled="dised"/>
      <van-cell
        title="教练"
        v-model="coachtitle"
        is-link
        @click="showCoach = true;"/>
      <van-field v-model="postForm.data.num" type="number" label="课时数" placeholder="请输入" />
      <van-cell
        title="支付方式"
        value="现金支付"
        is-link/>
    </van-cell-group>
    <the-btnbar :loadSta="subSta" text="创建订单"></the-btnbar>
  </form>

   <!-- 选择教练弹出层 -->
  <van-popup v-model="showCoach" position="right" class="buyed-users">
    <van-radio-group v-model="radio">
      <van-radio checked-color="#4b0" class="buyed-users__box" v-for="(item,index) in coachList" :key="index" :name="item.coachId" @click="checkCoach(item)">
          <div span="22" class="clear">
            <img src="" alt="">
            <div class="clear buyed-users__info">
              <div class="clear">
                <div class="left c4 fs2">{{ item.realName }}</div>
              </div>
              <div class="buyed-users__auth mtn fs1 c9">
                <span class="c9">{{item.title | titleFilter}} / </span>
                <span class="green">累计上课{{ item.lessons?item.lessons:0 }}课时</span>
              </div>
            </div>
          </div>
      </van-radio>
    </van-radio-group>
  </van-popup>
</div>
</template>
<script>
import Vue from 'vue';
import func from "@/assets/scripts/func";
import TheBtnbar from './components/TheBtnBar';
import {
  Cell, CellGroup,Checkbox, CheckboxGroup,SwitchCell,Picker,Row, Col,Toast
} from 'vant';

Vue.use(Cell).use(CellGroup).use(Checkbox).use(CheckboxGroup).use(SwitchCell).use(Picker).use(Row).use(Col).use(Toast);

export default {
  components: {
    TheBtnbar
  },
  filters: {
    titleFilter(status) {
      // 教练职称
      const statusMap = {
        assistant: '助教',
        junior: '初级教练',
        intermediate: '中级教练',
        senior: '高级教练'
      }
      return statusMap[status]
    }
  },
  data() {
    return {
      dised:false, //默认可以编辑
      subSta:false, //提交时 按钮状态
      radio:'',
      clubInfo:[], //场馆信息
      coachtitle:'请选择',
      coachprice:'',
      coachjob:'senior',
      showCoach:false,
      coachList:{}, //教练列表

      classInfo:{}, //课程信息
      userInfo:{
        name:'',
        mobile:''
      },
      postForm:{
        userId:this.$route.query.userId,
        targetType:'clubPtCourse',
        data:{
          coachId:'',
          num:''
        }
      }
    }
  },
  created(){
    let uid = this.$route.query.userId

    let _this = this
    // 获取用户信息
    if(uid){
      _this.$http.post('user/get',{
        id:uid
      }).then(function(res){
        if(!res.data.code){
          _this.userInfo.name = res.data.value.nickname
          
          if(res.data.value.mobile!==''){
            _this.userInfo.mobile = res.data.value.mobile
            _this.dised = true //有手机号不能修改
          }
        }else{
          // Toast(res.data.message)
        }
      })
    }

    // 获取教练列表
    this.$http.post('club_coach_manage/getList').then(res => {
      if (!res.data.code) {
        this.coachList = res.data.value
      } else {
        //Toast.fail(res.data.message);
      }
    })
    
    // 取场馆信息
    this.$http.get('club_manage/getInfo').then(res => {
      if(!res.data.code){
        _this.clubInfo = res.data.value 
      }else{
        // Toast(res.data.message)
      }       
    })
  },
  methods: {
    validMobile:function(value){
      let reg=11 && /^((13|14|15|17|18)[0-9]{1}\d{8})$/;
      if (value && !reg.test(value)) {
        return false
      } else {
        return true
      }
    },
    checkCoach(item){
      //选择教练
      this.coachtitle = item.realName;  //教练名称
      this.coachprice = item.price; //课时价格
      this.coachjob = item.title; //教练等级
      this.postForm.data.coachId = item.coachId;

      this.showCoach = false      
    },
    checkForm: function(){
      
      // if(!this.validMobile(this.userInfo.mobile)){
      //   Toast.fail('手机号格式不正确'); return false;
      // }
      if(!this.postForm.data.coachId){
        Toast.fail('请选择教练'); return false;
      }
      if(!this.postForm.data.num){
        Toast.fail('请填写课时数'); return false;
      }

      let _this = this
      let temp = JSON.parse(JSON.stringify(_this.postForm))
      temp.data.userInfo = _this.userInfo
      temp.data = JSON.stringify(temp.data)
      
      _this.subSta = true
      // 提交表单
      _this.$http.post('order_manage/create',temp).then(function(res){
          if(res.data.code == 0){
            Toast.success({                
              message:'创建成功！',
              duration:1000 
            })
            setTimeout(function(){
              _this.$router.go(-1)
            }, 1000) 
          }else{
            Toast(res.data.message)
            _this.subSta = false
          }
      })
    },
  },
  computed: {
    totalPrice: function () {
      // 防止小数
      var m=0,
      s1=this.postForm.data.num.toString(),  //转为字符串
      s2=this.coachprice.toString();

      try{m+=s1.split(".")[1].length}catch(e){} 
      try{m+=s2.split(".")[1].length}catch(e){}

      return Number(s1.replace(".",""))*Number(s2.replace(".",""))/Math.pow(10,m)
    }
  }
}
</script>
<style lang="less" scoped>
// 已购买者弹出层
.buyed-users {
    &__box {
      display: block;
      border-bottom: 0.01rem #f6f6f6 solid;
      padding: 0.15rem;
    }
    width: 80%;
    height: 100%;
    &__item {
      display: block;
      width: 100%;
    }
    &__info {
        overflow: hidden;
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/manage/PrivateCourseAdd.vue